module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Liedertswil-3b26262692c8689d299597a2c5afd648.png";